angular.module('jv.TriggerOnView.Directive', [])
.directive('jvTriggerOnView', ['$http', '$q', '$log', '$timeout', '$compile', '$window',
    function ($http, $q, $log, $timeout, $compile, $window) {
        var directiveDefinitionObject = {
            scope: {},
            link: function($scope, iElm, iAttrs){
                    $(iElm).waypoint(function(direction) {
                        var id = $(iElm);
                    },{
                        offset: '100%'
                    });
            }
        };
        return directiveDefinitionObject;
    }]);